import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, CircleAlert, LogIn } from "lucide-react";
import Brand from "../components/Brand";
import Loader from "../components/Loader";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return <Loader message="در حال بررسی نشست شما…" />;
  }
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      navigate(location.state?.from || "/dashboard", { replace: true });
    } catch (e) {
      setError(e.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-card">
        <div className="auth-head">
          <Brand subtitle="پنل مدیریت" />
          <h1>ورود به پنل</h1>
          <p>برای ادامه، نام کاربری و رمز عبور خود را وارد کنید.</p>
        </div>

        {error && (
          <div className="alert alert-error">
            <CircleAlert size={17} strokeWidth={2} aria-hidden="true" />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label htmlFor="username">نام کاربری</label>
            <input
              id="username"
              name="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="نام کاربری خود را وارد کنید"
              required
            />
          </div>

          <div className="field">
            <label htmlFor="password">رمز عبور</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="رمز عبور خود را وارد کنید"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
            {submitting ? (
              "در حال ورود…"
            ) : (
              <>
                <LogIn size={18} strokeWidth={2} aria-hidden="true" />
                ورود
              </>
            )}
          </button>
        </form>

        <p className="auth-foot">
          <Link to="/">
            <ArrowRight size={15} strokeWidth={2} aria-hidden="true" />
            بازگشت به صفحه اصلی
          </Link>
        </p>
      </div>
    </div>
  );
}
